import { render, staticRenderFns } from "./BalancesPage.vue?vue&type=template&id=34c77f9b"
import script from "./BalancesPage.vue?vue&type=script&lang=js"
export * from "./BalancesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports